import React, { Fragment } from 'react';
import { defaultFormat } from '../../../Utils/DateFormat';
import { numberFormat, capitalize, formatPrice } from '../../../Utils/Common';
import Pagination from 'react-js-pagination';
import DynamicFont from 'react-dynamic-font';
import { Link } from 'react-router-dom';
import moment from 'moment';

export class DeliveryPickingTemplate extends React.PureComponent {
    // function ReceivingPrintContent({ po_items, receivingData, deliveryDate, single_receiving, }) {
    constructor(props) {
        super(props);
        this.divScrollRef = React.createRef();

        let img_url = '/app-assets/images/logo/sample-logo.png';
        const tableRows = this.renderExtrRow(this.props.print_rows);
        let totalItemsCount = this.props.si_data.items.length;

        // Set itemsCountPerPage to 5 if the totalItemsCount is 7, 15, 23, or 31
        let itemsCountPerPage = [7, 15, 23, 31].includes(totalItemsCount)
            ? 6
            : 8;

        this.state = {
            auth: this.props.auth,
            si_data: this.props.si_data,
            activePage: 1,
            itemsCountPerPage: itemsCountPerPage,
            totalItemsCount: totalItemsCount,
            pageRangeDisplayed: 5,
            img_url: img_url,
            tableRows: tableRows,
            print: this.props.print,
            subs_setting: this.props.subs_setting,
        };
    }

    handlePageChange(pageNumber) {
        this.setState({ activePage: pageNumber });
        this.divScrollRef.current.scrollIntoView();
    }

    renderExtrRow(numberOfRows) {
        const tableRows = [];
        for (var i = 0; i < numberOfRows; i++) {
            tableRows.push(
                <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                </tr>
            );
        }

        return tableRows;
    }

    renderPrint(page, totalPage) {
        let auth = this.state.auth;
        let si_data = this.props.si_data;

        this.setState({ totalItemsCount: this.props.si_data.items.length });

        // console.log(si_data);

        let subId = '5fbce7782151301e660fa0d4';

        let img_url =
            auth.user.subscriber_id == subId
                ? '/monaki.png'
                : '/app-assets/images/logo/sample-logo.png';
        let company =
            auth.user.subscriber_id == subId ? 'Monikki Enterprises' : '';
        let address =
            auth.user.subscriber_id == subId
                ? '7i Bellagio 3 Forbestown Rd cor Burgos Circle BGC Taguig'
                : '';
        let contact = auth.user.subscriber_id == subId ? '02-7368-2071' : '';
        let email =
            auth.user.subscriber_id == subId
                ? 'mysecret.ph23@gmail.com.com'
                : '';

        let img_class =
            auth.user.subscriber_id == subId
                ? 'print-logo temp-logo'
                : 'print-logo';

        let temp_footer =
            auth.user.subscriber_id == subId ? (
                <div className="col-md-12">
                    <div className="f-14b pt-1 pb-2">
                        <div className="f-12">
                            {company} | {address} | {contact} | {email}{' '}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="col-md-6 col-print-6 ">
                    <ul className="f-16b ul-print-paw">
                        <li>Phone #</li>
                        <li>Address</li>
                        <li>Website</li>
                    </ul>
                </div>
            );
        const tableRows = [];

        const totalItemsCount = si_data.items.length;
        var showItemsTo = page * this.state.itemsCountPerPage;
        var showItemsFrom = showItemsTo - this.state.itemsCountPerPage;
        showItemsTo = showItemsTo - 1;
        let extraRowsCount = this.state.itemsCountPerPage;
        if (this.state.print == 0) {
            // extraRowsCount -= 15;
        }

        si_data.items.map((item, i) => {
            if (showItemsFrom <= i && showItemsTo >= i) {
                extraRowsCount--;
            }
        });

        const DynamicSkuStyle = {
            'max-width': '150px',
            fontSize: '1rem',
            lineHeight: '1.45',
            overflow: 'hidden',
            'text-decoration': 'underline',
        };

        const DynamicStringStyle = {
            // 'max-width': '150px',
            fontSize: '1rem',
            lineHeight: '1.45',
            overflow: 'hidden',
            'text-decoration': 'underline',
        };

        const customerAddress = [
            si_data.customer.street1,
            si_data.customer.street2 && ', ',
            si_data.customer.street2,
            (si_data.customer.street1 || si_data.customer.street2) && ', ',
            si_data.customer.city,
            si_data.customer.city && si_data.customer.state && ', ',
            si_data.customer.state,
        ]
            .filter(Boolean)
            .join('');

        // const { company_name, company_address, company_landline, company_email } = this.props.si_data.subs_setting;

        // const customer_address = si_data.customer != null ? si_data.customer.street1 && si_data.customer.street1  + ', ' + si_data.customer.city && si_data.customer.city + ' ' + si_data.customer.country && si_data.customer.country.label : '';

        const template_setting = this.props.si_data.template_setting;

        const subs_setting = this.state.subs_setting;
        const currencyDisplay =
            subs_setting &&
            subs_setting.currency &&
            subs_setting.currency.code &&
            subs_setting.currency.code.checked
                ? 'code'
                : 'symbol';

        // console.log('si_data', si_data);
        const thStyle = {
            border: 'none',
            padding: '4px',
            fontWeight: 'bold',
        };

        const tdStyle = {
            border: 'none',
            padding: '4px',
        };

        return (
            <div
                className="print-page"
                style={{
                    fontFamily: '"Courier New", Courier, monospace',
                    fontSize: '12px',
                    padding: '1.5rem',
                }}
            >
                <div className="d-flex justify-content-between mb-2">
                    <div>
                        <div>Customer: {si_data.customer.name}</div>
                        <div>Address: {customerAddress}</div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                        <div>Delivery Date: {si_data.delivery_date_string}</div>
                        <div>
                            Delivery No.: {si_data.delivery_receipt_no}
                        </div>{' '}
                        {si_data.sales_order_no && (
                            <div>Sales Order No.: {si_data.sales_order_no}</div>
                        )}
                        {/* <div>Terms: {si_data.payment_terms.label}</div> */}
                    </div>
                </div>

                <table
                    style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        border: 'none',
                        marginBottom: '1rem',
                    }}
                >
                    <thead>
                        <tr>
                            <th style={thStyle}>LOT NO.</th>
                            <th style={thStyle}>PRODUCT</th>
                            <th style={thStyle}>QTY</th>
                            <th style={thStyle}>UNIT</th>
                            <th style={thStyle}>LOCATION</th>
                            <th style={thStyle}>EXPIRY DATE</th>
                        </tr>
                    </thead>
                    <tbody>
                        {si_data.items.map((item, index) => (
                            <tr key={index}>
                                <td style={tdStyle}>{item.product_lot}</td>
                                <td style={{ ...tdStyle, textAlign: 'left' }}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: '4px',
                                        }}
                                    >
                                        {/* {item.product_image && (
                                            <img
                                                src={item.product_image}
                                                style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    objectFit: 'cover',
                                                    border: '1px solid #ccc',
                                                }}
                                            />
                                        )} */}
                                        <div style={{ lineHeight: '1.2' }}>
                                            <div>{item.product_name}</div>
                                            {item.barcode && (
                                                <div
                                                    style={{ fontSize: '10px' }}
                                                >
                                                    {item.barcode}
                                                </div>
                                            )}
                                            {item.description && (
                                                <div
                                                    style={{ fontSize: '10px' }}
                                                >
                                                    {item.description}
                                                </div>
                                            )}
                                            {item.brand && (
                                                <div
                                                    style={{ fontSize: '10px' }}
                                                >
                                                    {item.brand}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </td>
                                <td style={tdStyle}>{item.qty}</td>
                                <td style={tdStyle}>
                                    {item.product_unit_name}
                                </td>
                                <td style={tdStyle}>
                                    {item ? item.location : ''}
                                </td>
                                <td style={tdStyle}>
                                    {item.expiry_date
                                        ? moment(item.expiry_date).format(
                                              'MM/DD/YYYY'
                                          )
                                        : ''}
                                </td>
                            </tr>
                        ))}
                        {this.renderExtrRow(extraRowsCount)}
                    </tbody>
                </table>
            </div>
        );
    }

    renderMultiplePage() {
        const tableRows = [];
        const tableRowsTry = [];
        let numberOfPage = Math.ceil(
            this.state.totalItemsCount / this.state.itemsCountPerPage
        );
        for (let i = 1; i <= numberOfPage; i++) {
            tableRows.push(this.renderPrint(i, Math.floor(numberOfPage)));
        }
        return tableRows;
    }

    render() {
        // console.log(this.state);
        this.setState({ totalItemsCount: this.props.si_data.items.length });
        let numberOfPage = Math.ceil(
            this.state.totalItemsCount / this.state.itemsCountPerPage
        );

        return (
            <Fragment>
                {/*
                <div className="temp-watermark">
                    <h1>{si_data.status == 'draft' ? si_data.status : ''}</h1>
                </div>
            */}

                <div ref={this.divScrollRef} className="main-print-div">
                    {this.state.print == 0 ? (
                        this.renderPrint(this.state.activePage, numberOfPage)
                    ) : (
                        <Fragment>{this.renderMultiplePage()}</Fragment>
                    )}{' '}
                </div>

                <div className="hidden-print d-flex justify-content-center pagination-print">
                    <Pagination
                        className="pagination"
                        itemClass="page-item"
                        linkClass="page-link"
                        activePage={this.state.activePage}
                        itemsCountPerPage={this.state.itemsCountPerPage}
                        totalItemsCount={this.state.totalItemsCount}
                        pageRangeDisplayed={this.state.pageRangeDisplayed}
                        onChange={this.handlePageChange.bind(this)}
                    />
                </div>
            </Fragment>
        );
    }
}

export default DeliveryPickingTemplate;
